type SigningName = { acc_firstName?: string | null; acc_lastName?: string | null; name?: string | null; email?: string | null };

const usable = (value?: string | null) => {
  const text = value?.trim() || '';
  return /^(null|undefined)(\s+(null|undefined))*$/i.test(text) ? '' : text;
};

export const signingParticipantName = (user: SigningName) =>
  [usable(user.acc_firstName), usable(user.acc_lastName)].filter(Boolean).join(' ')
  || usable(user.name) || usable(user.email) || '—';
